module.exports = __webpack_public_path__ + "static/media/black&white.ac848c91.png";